import ControlledSwitch from './ControlledSwitch';

export default ControlledSwitch;
